import * as Yup from "yup";

export const defaultKeyContact = {
  name: "",
  phone: "",
  alternate_phone: "",
  email: "",
  address: "",
  designation: "",
  comments: "",
};
